module.exports = ".loader {\n  display: table;\n  margin: auto;\n  text-align: center;\n  font-size: 50px;\n  color: #f44336; }\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg); } }\n\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loader/loader.component.scss
// module id = ./src/app/shared/loader/loader.component.scss
// module chunks = main